import { Boxes, Container, PackageOpen, Refrigerator } from "lucide-react";

const services = [
  {
    id: "cajas",
    icon: Boxes,
    title: "Envío de Cajas",
    description: "Enviamos cajas de todos los tamaños con total seguridad a cualquier parte de República Dominicana.",
    image: "/services/cajas.png",
  },
  {
    id: "tanques",
    icon: Container,
    title: "Tanques y Carga Grande",
    description: "Transporte seguro de tanques, barriles y mercancía pesada con manejo especializado.",
    image: "/services/tanques.png",
  },
  {
    id: "paquetes",
    icon: PackageOpen,
    title: "Paquetes Personales",
    description: "Entregas rápidas de paquetes familiares o personales, puerta a puerta en toda RD.",
    image: "/services/paquetes.png",
  },
  {
    id: "electrodomesticos",
    icon: Refrigerator,
    title: "Electrodomésticos",
    description: "Envío de neveras, estufas, lavadoras, televisores y mucho más con embalaje profesional.",
    image: "/services/electrodomesticos.png",
  },
];

export default function Services({ onQuoteClick }) {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="relative py-20 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-[#0B1F4D]">
            Nuestros Servicios
          </h2>
          <div className="mt-3 mx-auto w-24 h-1 bg-[#D61F26]" />
        </div>

        {/* Grid */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <button
                key={s.id}
                data-testid={`service-card-${s.id}`}
                onClick={onQuoteClick}
                className="group relative text-left overflow-visible bg-white border border-gray-100 shadow-sm transition-all hover:-translate-y-1 hover:shadow-xl"
              >
                {/* Image */}
                <div className="aspect-[3/4] w-full overflow-hidden bg-gradient-to-b from-gray-50 to-gray-100 relative">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  {/* Floating red circular icon - anchored to bottom of image */}
                  <div className="absolute left-6 -bottom-7 w-14 h-14 rounded-full bg-[#D61F26] flex items-center justify-center shadow-lg transition-transform group-hover:scale-110 z-10">
                    <Icon className="w-6 h-6 text-white" strokeWidth={2.25} />
                  </div>
                </div>
                {/* Body */}
                <div className="px-6 pt-12 pb-7">
                  <h3 className="font-display text-lg lg:text-xl font-extrabold uppercase tracking-tight text-[#0B1F4D] leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-4 text-sm text-gray-600 leading-relaxed">
                    {s.description}
                  </p>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
